import React from 'react';
import Icon from '../../../components/AppIcon';


const CompanyContact = ({ contact }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6 lg:p-8">
      <h2 className="text-2xl font-bold text-foreground mb-6">Contact Information</h2>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="space-y-6">
          <div>
            <h3 className="text-lg font-semibold text-foreground mb-4">Office Locations</h3>
            <div className="space-y-4">
              {contact?.offices?.map((office, index) => (
                <div key={index} className="p-4 bg-muted/50 border border-border rounded-lg">
                  <div className="flex items-start gap-3 mb-3">
                    <Icon name="MapPin" size={20} className="text-primary flex-shrink-0 mt-1" />
                    <div>
                      <h4 className="font-semibold text-foreground mb-1">{office?.name}</h4>
                      <p className="text-sm text-muted-foreground">{office?.address}</p>
                    </div>
                  </div>
                  {office?.phone && (
                    <div className="flex items-center gap-3 text-sm text-muted-foreground">
                      <Icon name="Phone" size={16} />
                      <span>{office?.phone}</span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-foreground mb-4">HR Contact</h3>
            <div className="p-4 bg-muted/50 border border-border rounded-lg space-y-3">
              <div className="flex items-center gap-3">
                <Icon name="Mail" size={18} className="text-primary" />
                <a href={`mailto:${contact?.hrEmail}`} className="text-primary hover:underline">
                  {contact?.hrEmail}
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Icon name="Phone" size={18} className="text-primary" />
                <a href={`tel:${contact?.hrPhone}`} className="text-primary hover:underline">
                  {contact?.hrPhone}
                </a>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-foreground mb-4">Follow Us</h3>
            <div className="flex items-center gap-3">
              {contact?.social?.map((platform) => (
                <a
                  key={platform?.name}
                  href={platform?.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center hover:bg-primary/20 transition-smooth"
                >
                  <Icon name={platform?.icon} size={20} className="text-primary" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div>
          <h3 className="text-lg font-semibold text-foreground mb-4">Headquarters Location</h3>
          <div className="aspect-video rounded-lg overflow-hidden border border-border">
            <iframe
              width="100%"
              height="100%"
              loading="lazy"
              title={contact?.headquarters?.name}
              referrerPolicy="no-referrer-when-downgrade"
              src={`https://www.google.com/maps?q=${contact?.headquarters?.lat},${contact?.headquarters?.lng}&z=14&output=embed`}
              className="w-full h-full"
            />
          </div>
          <div className="mt-4 p-4 bg-muted/50 border border-border rounded-lg">
            <p className="text-sm text-muted-foreground">{contact?.headquarters?.address}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyContact;